/* © CNES */
import { useContext, useMemo } from 'react';
import { productTypeOptions } from '../../../../../assets/config/filters/PostelReferenciel';
import {
  filterSections,
  refMissions,
} from '../../../../../assets/config/filters/Referenciel';
import { FilterDataContext } from '../../../../../context/FilterDataContext';
import { CustomAccordion } from '../../../../shared/Accordion/CustomAccordion';
import { DATASET } from '../../../../shared/Constants';
import { FilterSelectButtons } from '../FilterSelectButtons/FilterSelectButtons';

/**
 * Product Type Condition Props.
 */
export interface ProductTypeConditionProps {
  handleChange: (e: any, key: string) => void;
}

/**
 * Product types Condition to display other filters depending on data product selection.
 * @param productTypeOptions all data product for selected Missions / Platforms.
 * @param handleChange Function to handle change on data product selection.
 * @returns productTypeCondition Element.
 */
export const ProductTypeCondition = ({
  handleChange,
}: ProductTypeConditionProps) => {
  const { filterData } = useContext(FilterDataContext);
  /**
   * set new values of product type button select
   * @param value The product type to handle.
   */
  const onChangeProductType = (value: string | number[]) => {
    handleChange(value, filterSections.productType.param);
  };

  const productType = useMemo(() => {
    const mission = refMissions.find(
      (el) => JSON.stringify(el.key) === JSON.stringify(filterData[DATASET])
    );
    if (mission) {
      return productTypeOptions.filter((el) =>
        (el.missionId as number[]).includes(mission?.value)
      );
    }
    return productTypeOptions;
  }, [filterData]);

  return (
    <div className="productTypeFilter">
      <CustomAccordion
        title={filterSections.productType.title}
        children={
          productType && productType.length > 0 ? (
            <FilterSelectButtons
              name={filterSections.productType.param}
              options={productType}
              handleChange={onChangeProductType}
            />
          ) : (
            <div>Please select a postel collection first.</div>
          )
        }
      />
    </div>
  );
};
